// Privacy Policy page - uses tenant branding when on tenant subdomain
import React from "react"
import { Link } from "react-router-dom"
import { useBranding } from "@/contexts/branding-context"
import { getCurrentTenantId } from "@/lib/tenant"

export default function PrivacyPage() {
  const tenantId = getCurrentTenantId()
  const { logoUrl, businessName, privacyPolicyName } = useBranding()

  const displayName = privacyPolicyName
  const logoSrc = tenantId && logoUrl ? logoUrl : "/logo-with-text.png"

  return (
    <main className="max-w-2xl mx-auto py-16 px-4">
      <Link to="/" className="flex justify-center mb-8">
        <img src={logoSrc} alt={`${businessName} Logo`} className="h-16 w-auto" />
      </Link>
      <h1 className="text-3xl font-bold mb-6">{displayName}</h1>
      <p className="mb-4">Your privacy is important to us. This {displayName} explains how {businessName} collects, uses, and protects your information.</p>
      <h2 className="text-xl font-semibold mt-6 mb-2">What Data We Collect</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>We only collect information necessary for gym membership management, such as your name, email address, and phone number.</li>
        <li>We do not collect or store any payment information, health data, or personal data unrelated to gym membership.</li>
        <li>We do not track your activity outside of the {businessName} platform.</li>
      </ul>
      <h2 className="text-xl font-semibold mt-6 mb-2">How We Use Your Data</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>To manage your gym membership and provide access to gym services.</li>
        <li>To communicate with you about your membership, appointments, or important updates.</li>
        <li>To comply with legal requirements and ensure the security of our platform.</li>
      </ul>
      <h2 className="text-xl font-semibold mt-6 mb-2">Data Sharing</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>We do not sell or share your personal data with third parties, except as required by law.</li>
        <li>Your data is only accessible to authorized staff for gym management purposes.</li>
      </ul>
      <h2 className="text-xl font-semibold mt-6 mb-2">Your Rights</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>You can request to access, update, or delete your membership data at any time by contacting us.</li>
        <li>We will respond to your requests promptly and transparently.</li>
      </ul>
      <h2 className="text-xl font-semibold mt-6 mb-2">Contact</h2>
      <p className="mb-4">If you have any questions or concerns about your privacy, please contact our staff at the gym or via the contact information provided in your membership agreement with {businessName}.</p>
      <p className="mt-8 text-sm text-muted-foreground">This policy may be updated from time to time. Last updated: June 2025.</p>
    </main>
  )
}
